import { useState } from "react";
import { FormInput } from "@spectrumselect/mi-ui-react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "./PasswordInput.scss"

const PasswordInput = (props) => {
  const [show, setShow] = useState(false)
  return (
    <div className="password-input">
      <FormInput
        type={show ? "text" : "password"}
        {...props}
      />
      <span onClick={() => setShow(a => (!a))}>{show ? <VisibilityOffIcon fontSize='large' /> : <VisibilityIcon fontSize='large' />}</span>
    </div>
  )
}

export default PasswordInput
